import { Component, OnInit, OnDestroy, effect } from '@angular/core';
import { ReactiveFormsModule, Validators, FormGroup, FormBuilder  } from '@angular/forms';

import { DirectSessionLogicService } from '../../../shared/direct-session-logic.service';
import { CustomerFormat } from '../../../shared/models/customerFormat.model';
import { environment } from '../../../../environments/environment';
import { GoogleService } from '../../../shared/google.service';
import { uspsData } from '../../../shared/models/uspsData';
import { standardizedAddress } from '../../../shared/models/standardizedAddress';
import * as bootstrap from 'bootstrap';
import { GoogleMapsModule } from '@angular/google-maps';
import { PlanService } from '../../../shared/plan-data.service';
import { PromoService } from '../../../shared/promo.service';

@Component({
  selector: 'app-form-contact-info',
  template: `
  <section>
    <div>
      <div class="card-body" >
          <!-- <h3>{{this.session.plan.name}} plan</h3> -->
        <h3>Let's keep your identity <strong>Safe!</strong></h3>
        <p aria-label="Title for contact information step">Provide your contact information below...</p>
          <form [formGroup]="contactForm" >
            <div class="row ">
                <div class="col-lg-6 col-md-12  mb-3">
                  <label for="firstName" class="form-label input-labels">First name</label>
                  <input formControlName="firstName" type="text" class="form-control" name="firstName" placeholder="Enter name" autocomplete="given-name" >
                  @if(contactForm.controls['firstName'].invalid && contactForm.controls['firstName'].touched){
                    <div class="text-danger"> Please enter a valid first name. </div>
                  }
                </div>
                <div class="col-lg-6 col-md-12  mb-3">
                  <label for="lastName" class="form-label input-labels">Last name</label>
                  <input formControlName="lastName" type="text" class="form-control" name="lastName" placeholder="Enter name" autocomplete="family-name" >
                  @if(contactForm.controls['lastName'].invalid && contactForm.controls['lastName'].touched){
                    <div class="text-danger"> Please enter a valid last name. </div>
                  }
                </div>
            </div>
            <div class="row mb-3">
              <div class="col-12">
                <label for="address" class="form-label input-labels">Address</label>
                @if (isAddressVerified && isAddressComplete && verifyAddress) {
                  <span class="ms-1">
                    <img src="assets/Icons/check-circle.svg" alt="checkmark" title="Address Verified">
                  </span>
                }
                @if (!isAddressVerified && isAddressComplete && verifyAddress) {
                  <span class="ms-1">
                    <img src="assets/Icons/exclamation-circle-red.svg" alt="checkmark" title="Address Not Verified">
                  </span>
                }
                <input id="address1" formControlName="address" type="text" class="form-control address-field" name="address" placeholder="Enter an address" autocomplete="street-address" >
                @if (contactForm.controls['address'].invalid && contactForm.controls['address'].touched) {
                  <div class="text-danger"> Please enter a valid address. </div>
                }
              </div>
            </div>

            <div class="row ">
              <div class="col-lg-9 col-md-12  mb-3">
                <label for="city" class="form-label input-labels">City</label>
                <input formControlName="city" name="city" type="text" class="form-control address-field" placeholder="Enter City" autocomplete="address-level2">
                @if (contactForm.controls['city'].invalid && contactForm.controls['city'].touched) {
                  <div class="text-danger"> Please enter a valid city. </div>
                }
              </div>

              <div class="col-lg-3 col-sm-6 col-xs-12 mb-3">
                <label for="state" class="form-label input-labels">State</label>
                <select formControlName="state" name="state" class="form-control address-field">
                  @for(stateID of this.stateIDs; track stateID){
                    <option [value]="stateID">{{stateID}}</option>
                  }
                </select>
                @if (contactForm.controls['state'].invalid && contactForm.controls['state'].touched) {
                  <div class="text-danger"> Please select a valid state. </div>
                }
              </div>
            </div>

            <div class="row ">
              <div class="col-lg-6 col-md-12  mb-3">
                <label id="zipcode" for="zipCode" class="form-label input-labels">ZIP code</label>
                <input formControlName="zipCode" type="tel" class="form-control address-field" name="zipCode" placeholder="Enter ZIP Code" inputmode="numeric" autocomplete="postal-code" required minlength="5" maxlength="5" >
                @if(contactForm.controls['zipCode'].invalid && contactForm.controls['zipCode'].touched){
                  <div class="text-danger"> Please enter a valid zip code. </div>
                }
              </div>

              <div class="col-md-6 col-sm-12  mb-3">
                <label for="country" class="form-label input-labels">Country</label>
                <select formControlName="country" name="country" class="form-control address-field">
                  @for(country of this.validCountries; track country){
                    <option [value]="country">{{country}}</option>
                  }
                </select>
                @if(contactForm.controls['country'].invalid && contactForm.controls['country'].touched){
                  <div class="text-danger"> Please select a valid country. </div>
                }
              </div>
            </div>

            <div class="row ">

              <div class="col-lg-6 col-md-12  mb-3">
                <label for="phone" class="form-label input-labels">Phone number</label>
                <input formControlName="phone" type="tel" class="form-control" name="phone" placeholder="Enter phone number" inputmode="decimal" autocomplete="tel-national" required minlength="10" maxlength="12">
                @if(contactForm.controls['phone'].invalid && contactForm.controls['phone'].touched){
                  <div class="text-danger"> Please enter a valid phone number. </div>
                }
              </div>

              <div class="col-lg-6 col-md-12  mb-3">
                <label for="email" class="form-label input-labels">Email address</label>
                <input formControlName="email" type="email" class="form-control" name="email" placeholder="Enter email address" inputmode="email" autocomplete="email" >
                @if (contactForm.controls['email'].invalid && contactForm.controls['email'].touched) {
                  <div class="text-danger"> Please enter a valid email. </div>
                }
            </div>

          </div>
        </form>

        <hr>
        <p class="legal-notice">{{this.contactPermissionMessage}}</p>
      </div>
    </div>
    
    <div id="modalAddressMismatch" class="modal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Verify Address</h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="card">
                  <div class="card-header">
                    <span>Entered Address</span>
                  </div>
                  <div class="card-body">
                    <div>{{enteredAddress.firstAddressLine}}</div>
                    <div>
                      <span>{{enteredAddress.city}}</span>,
                      <span>{{enteredAddress.state}}</span>
                    </div>  
                    <div>{{enteredAddress.zipCode}}</div>
                    <button class="btn btn-sm btn-warning w-100 mt-2" (click)="dismissAddressUpdate()">Use Entered</button>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="card">
                  <div class="card-header">
                    <span>Verified Address</span>
                  </div>
                  <div class="card-body">
                    <div>{{uspsData?.standardizedAddress?.firstAddressLine}}</div>
                    <div>
                      <span>{{uspsData?.standardizedAddress?.city}}</span>,
                      <span>{{uspsData?.standardizedAddress?.state}}</span>
                    </div>
                    <div>{{uspsData?.standardizedAddress?.zipCode}}</div>
                    <button class="btn btn-sm btn-success w-100 mt-2" (click)="updateAddressFromUsps()">Use Verified</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
  `,
  styleUrls: ['./form-contact-info.component.scss'],
  standalone: true,
  imports: [ 
    ReactiveFormsModule, 
    GoogleMapsModule
  ]
})
export class FormContactInfoComponent implements OnInit, OnDestroy {
  
  contactForm: FormGroup = new FormGroup({});

  get customer(): CustomerFormat {
    return this.directSessionLogic.customerSignal();
  }

  private intervalId: any;

  firstName: string = '';
  lastName: string = '';
  email: string = '';
  phone: string = '';
  address: string = '';
  city: string = '';
  state: string = '';
  zipCode: string = '';
  country: string = '';

  verifyAddress:boolean = false;
  isAddressVerified:boolean = false; // set using this.setAddressValidationStatus(bool)
  isAddressComplete:boolean = false; // 
  uspsData:uspsData | any = {};
  enteredAddress = {} as standardizedAddress;
  verifiedAddress = {} as standardizedAddress;
  modalAddressMismatch:any = {};

  autocompleteAddress: boolean = true;
  autocomplete: google.maps.places.Autocomplete = {} as google.maps.places.Autocomplete;
  updateFormLockout: boolean = false;

  companyName: string = "";
  contactPermissionMessage: string = "we may contact you if you click next";

  nameRegex: RegExp = /^[a-zA-Z\-]+$/;
  phoneRegex: RegExp = /^([0-9]{3})[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  zipCodeRegex: RegExp = /[0-9]{5}/;
  emailRegex: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/;


  //list of all valid two character state IDs
  stateIDs: string[] = [
    "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", 
    "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", 
    "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", 
    "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", 
    "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
  ];

  validCountries: string[] = [
    "United States"
  ];

  constructor(
    public directSessionLogic: DirectSessionLogicService,
    private builder: FormBuilder,
    public googleService: GoogleService,
    public promoService: PromoService,
    public planService: PlanService
        
  ) {
    this.escapeCheck();

    effect(() => {
      let selectedPlan = this.directSessionLogic.planSelectedSignal();
      this.escapeCheck();
      if(this.planService.planSelectionFromUrl() != null && this.directSessionLogic.planSelectedSignal().name == undefined){
        this.planService.selectPlan();
        console.log("---Plan set in first page",this.planService.planSelectionFromUrl())
      }
    });

    effect(() => {
      if(this.customer.firstName != undefined){
        this.setContactFromSession();          
      }
    });


    effect(() => {
      let items = this.directSessionLogic.cartItemsSignal();
    });


    this.getSessionInfo();
    this.getConfigData();
    this.DEBUGMODE();
  }

  escapeCheck(){
    if(this.directSessionLogic.planSelectedSignal().name === undefined || this.directSessionLogic.planSelectedSignal().name === null) {
      console.log("no plan selected, escaping to top level");
      this.directSessionLogic.escapeToTopLevelSignal();
    }
  }

  initAutocomplete() {
    let address1Field = document.querySelector("#address1") as HTMLInputElement;
    let autocompleteOptions = {
      componentRestrictions: { country: ["us"] },
      fields: ["address_components", "geometry"],
      types: ["address"],
    };
    this.autocomplete = new google.maps.places.Autocomplete(address1Field, autocompleteOptions);
    this.autocomplete.addListener("place_changed", () => {
      const place = this.autocomplete.getPlace();
      if(place.address_components) {
        let addr = place.address_components;
        
        let streetNumber:string = addr.find((part) => part.types.includes('street_number'))?.long_name || '';
        let route:string = addr.find((part) => part.types.includes('route'))?.short_name || '';
        
        let address1:string = streetNumber + ' ' + route;
        let city:string = addr.find((part) => part.types.includes('locality'))?.long_name || '';
        let state:string = addr.find((part) => part.types.includes('administrative_area_level_1'))?.short_name || '';
        let zip:string = addr.find((part) => part.types.includes('postal_code'))?.long_name || '';

        this.customer.address = address1;
        this.customer.city = city;
        this.customer.state = state;
        this.customer.zip = zip;
        this.directSessionLogic.updateCustomerSignal(this.customer);

        this.contactForm.patchValue({
          address:      this.customer.address,
          city:         this.customer.city,
          state:        this.customer.state,
          zipCode:      this.customer.zip
        });
      }
    });
  }

  //Add on exit function to save form data to session
  //ONLY if customer has a name and either (email or phone number)

  getSessionInfo() {    
    if(this.customer != undefined) {
      this.setContactFromSession();
    }else{
      this.startNewContactForSession();
    }
  }

  async getConfigData(){
    this.companyName = environment.CompanyInfo.CompanyName.toString();
    
    this.contactPermissionMessage = environment.LegalData.find( data => 
      data.legalRef == "contact"
      )?.legalText || "error getting contact permission message for $$company$$";

    this.contactPermissionMessage = this.contactPermissionMessage.replace(
      "$_$", this.companyName
    );
  }

  ngOnInit() {

    this.modalAddressMismatch = new bootstrap.Modal("#modalAddressMismatch",{
      keyboard: false,
      backdrop: true,
      focus: true,
    });

    this.stateIDs = this.stateIDs.sort();
    this.validCountries = this.validCountries.sort();



    // Set up interval to check form validity every second
    this.intervalId = setInterval(() => {
      if (this.contactForm.valid && !this.isUpdatedForm() && !this.updateFormLockout) {
        this.updateSessionCustomer();
      }
    }, 1000);


    //sub to each address field individually to help prevent extra API calls
    //otherwise we may accidentally call API repeatedly when filling out phone number, email, etc.
    this.contactForm.get('address')?.valueChanges.subscribe(x => {
      this.isAddressComplete = this.evalAddressCompleteness();
      if(this.isAddressComplete && this.verifyAddress)
      {
        this.validateAddress();
      }
    });
    this.contactForm.get('city')?.valueChanges.subscribe(x => {
      this.isAddressComplete = this.evalAddressCompleteness();
      if(this.isAddressComplete && this.verifyAddress)
      {
        this.validateAddress();
      }
    });
    this.contactForm.get('state')?.valueChanges.subscribe(x => {
      this.isAddressComplete = this.evalAddressCompleteness();
      if(this.isAddressComplete && this.verifyAddress)
      {
        this.validateAddress();
      }
    });
    this.contactForm.get('zipCode')?.valueChanges.subscribe(x => {
      this.isAddressComplete = this.evalAddressCompleteness();
      if(this.isAddressComplete && this.verifyAddress)
      {
        this.validateAddress();
      }
    });
    this.contactForm.get('country')?.valueChanges.subscribe(x => {
      this.isAddressComplete = this.evalAddressCompleteness();
      if(this.isAddressComplete && this.verifyAddress)
      {
        this.validateAddress();
      }
    });

    this.contactForm.valueChanges.subscribe((x) => {
      if(this.contactForm.valid){

        this.updateSessionCustomer();
        this.directSessionLogic.completeCurrentStepSignal();

        this.updateFormLockout = true;
        
        //probably want to submit as lead to lead API here, NO

      }else{
        if(this.directSessionLogic.getCurrentStepSignal()?.completed){
          console.log("invalid form, uncompleting step")
          this.directSessionLogic.unCompleteCurrentStepSignal();
        }
      }
    });
  }


  private updateSessionCustomer(){
    console.log('-----form is complete----');
    let cleansedPhoneNumber = this.contactForm.get('phone')?.value.toString().replace(/[-. ]/, '');

    this.customer.firstName =   this.contactForm.get('firstName')?.value;
    this.customer.lastName =    this.contactForm.get('lastName')?.value;
    this.customer.address =     this.contactForm.get('address')?.value;
    this.customer.city =        this.contactForm.get('city')?.value;
    this.customer.state =       this.contactForm.get('state')?.value;
    this.customer.zip =         this.contactForm.get('zipCode')?.value;
    this.customer.country =     this.contactForm.get('country')?.value;
    this.customer.phoneNumber = cleansedPhoneNumber;
    this.customer.email =       this.contactForm.get('email')?.value;
    
    this.directSessionLogic.updateCustomerSignal(this.customer);
  }

  private isUpdatedForm(): boolean{
    let updated = false;
    let cleansedPhoneNumber = this.contactForm.get('phone')?.value.toString().replace(/[-. ]/, '');

    updated = (
      this.customer.firstName != this.contactForm.get('firstName')?.value ||
      this.customer.lastName != this.contactForm.get('lastName')?.value ||
      this.customer.address != this.contactForm.get('address')?.value ||
      this.customer.city != this.contactForm.get('city')?.value ||
      this.customer.state != this.contactForm.get('state')?.value ||
      this.customer.zip != this.contactForm.get('zipCode')?.value ||
      this.customer.country != this.contactForm.get('country')?.value ||
      this.customer.phoneNumber != cleansedPhoneNumber ||
      this.customer.email != this.contactForm.get('email')?.value
    );

    return updated;
  }

  
  evalAddressCompleteness(): boolean {
    if(     this.contactForm.get('address')?.value
        &&  this.contactForm.get('city')?.value
        &&  this.contactForm.get('state')?.value
        &&  this.contactForm.get('zipCode')?.value
        &&  this.contactForm.get('country')?.value
        &&  this.contactForm.get('city')?.value.length > 2
        &&  this.contactForm.get('zipCode')?.value.length > 4)
    {
      return true;
    }
    else {
      return false;
    }
  }

  validateAddress() {
    let addressLinesInput:string[] = [ 
      this.contactForm.get('address')?.value,
      this.contactForm.get('city')?.value + ' '  + this.contactForm.get('state')?.value + ' ' + this.contactForm.get('zipCode')?.value
    ];
    this.googleService.validateAddress(addressLinesInput).subscribe({
      next: (res) => {
        if(res.result?.uspsData) {
          this.uspsData = res.result.uspsData;
          this.customer.deliveryPointCode = this.uspsData.deliveryPointCode;
          this.customer.deliveryPointCheckDigit = this.uspsData.deliveryPointCheckDigit;
          this.directSessionLogic.updateCustomerSignal(this.customer);

          //address exists but may or may not need small adjustments
          if(this.customer.deliveryPointCode) {
            /////////////////////////////////////////////////////////////////////////////////////////////////
            if(this.uspsData.standardizedAddress) {
              this.enteredAddress = {
                firstAddressLine: this.contactForm.get('address')?.value,
                city: this.contactForm.get('city')?.value,
                state: this.contactForm.get('state')?.value,
                zipCode: this.contactForm.get('zipCode')?.value,
                cityStateZipAddressLine: null,
                zipCodeExtension: null
              };
              
              let isExactMatch:boolean = true;
              if(this.enteredAddress.firstAddressLine.toLowerCase() !== this.uspsData.standardizedAddress.firstAddressLine.toLowerCase()) {
                isExactMatch = false;
              }
              if(this.enteredAddress.city.toLowerCase() !== this.uspsData.standardizedAddress.city.toLowerCase()) {
                isExactMatch = false;
              }
              if(this.enteredAddress.state.toLowerCase() !== this.uspsData.standardizedAddress.state.toLowerCase()) {
                isExactMatch = false;
              }
              if(!isExactMatch) {
                this.modalAddressMismatch.show();
              }        
            /////////////////////////////////////////////////////////////////////////////////////////////////
          }
          //plausible address but not verified and may not actually exist
          else {
            this.isAddressVerified = false;
          }
        }
        //not a plausible address
        else {
          this.isAddressVerified = false;
        }
        }
      }
    });
  }

  
  setAddressValidationStatus(newStatus:boolean) {
    let oldStatus = this.isAddressVerified;
    if(newStatus === oldStatus) {
      //relax
    }
    this.isAddressVerified = newStatus;
    if(newStatus === false) {
      this.customer.deliveryPointCode = '';
      this.customer.deliveryPointCheckDigit = '';
    }
  }

  /* Close modal after user selected the address as originally entered */
  dismissAddressUpdate() {
    this.modalAddressMismatch.hide();
  }

  /* User selected the usps verified address from the modal */
  updateAddressFromUsps() {
    this.customer.address = this.uspsData.standardizedAddress.firstAddressLine;
    this.customer.city = this.uspsData.standardizedAddress.city;
    this.customer.state = this.uspsData.standardizedAddress.state;
    this.customer.zip = this.uspsData.standardizedAddress.zipCode;
    this.directSessionLogic.updateCustomerSignal(this.customer);

    this.patchCustomerValues();

    this.modalAddressMismatch.hide();
    this.isAddressVerified = true;
  }


  async setContactFromSession(){
    this.startNewContactForSession();

    this.firstName =  this.customer.firstName;
    this.lastName =   this.customer.lastName;
    this.email =      this.customer.email;
    this.phone =      this.customer.phoneNumber;
    this.address =    this.customer.address;
    this.city =       this.customer.city;
    this.state =      this.customer.state;
    this.zipCode =    this.customer.zip;
    this.country =    this.customer.country;

    this.patchCustomerValues();

    if(!this.contactForm.valid){
      let invalidFields = "Invalid Fields: "
      for (const name in this.contactForm.controls) {
          if (this.contactForm.controls[name].invalid) {
            invalidFields += name + ", ";
          }
      }   
      
      console.log(invalidFields);
    }
  
    if(this.contactForm.valid){
      await this.directSessionLogic.sleep(100);
      this.directSessionLogic.completeCurrentStepSignal();
    }else{
      if(this.directSessionLogic.getCurrentStepSignal()?.completed){
        console.log("invalid form, uncompleting step")
        this.directSessionLogic.unCompleteCurrentStepSignal();
      }
    }
  }

  startNewContactForSession(){
    this.contactForm = this.builder.group({
      firstName:  ['', [Validators.required, Validators.minLength(2), Validators.maxLength(20) ]],
      lastName:   ['', [Validators.required, Validators.minLength(2), Validators.maxLength(20) ]],
      address:    ['', [Validators.required, Validators.minLength(6) ]],
      city:       ['', [Validators.required, Validators.minLength(2), Validators.maxLength(48) ]],
      state:      ['', [Validators.required, Validators.minLength(2), Validators.maxLength(2) ]],
      zipCode:    ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern(this.zipCodeRegex) ]],
      
      // setting default country
      // helps with address verification
      // only 1 option regardless
      // signed off as ok by GP and TS
      country:    ['United States', [Validators.required, Validators.minLength(2), Validators.maxLength(48) ]],
      phone:      ['', [Validators.required, Validators.minLength(10), Validators.maxLength(12), Validators.pattern(this.phoneRegex) ]],
      email:      ['', [Validators.required, Validators.email, Validators.pattern(this.emailRegex) ]],
    }); 
  }

  ngOnDestroy(): void {
    // Clear the interval when the component is destroyed
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  async DEBUGMODE() {
    let debugValue = environment.ConnectionInfo.localDebug === "true";
    
    if (debugValue && this.customer.firstName === "") {

      console.log("DEBUGMODE:", debugValue);

      this.customer.firstName = "John";
      this.customer.lastName = "SANDBOX";
      this.customer.email = "blankblakn@TESTTESTTEST.com";
      this.customer.phoneNumber = "5555555555";
      this.customer.address = "1234 Main St";
      this.customer.city = "Anytown";
      this.customer.state = "CA";
      this.customer.zip = "12345";
      this.customer.country = "United States";
  
      console.log("proxy account", this.customer);

      this.directSessionLogic.updateCustomerSignal(this.customer);

      this.patchCustomerValues();
          
    }
  }

  patchCustomerValues(){
    this.contactForm.patchValue({
      firstName:    this.customer.firstName,
      lastName:     this.customer.lastName,
      email:        this.customer.email,
      phone:        this.customer.phoneNumber,
      address:      this.customer.address,
      city:         this.customer.city,
      state:        this.customer.state,
      zipCode:      this.customer.zip,
      country:      this.customer.country
    });
  }
}


  

